<template>
  <div class="switch-container">
    <label v-if="$slots['default']" class="switch-label material-label">
      <slot />
    </label>
    <el-switch
      v-if="!readonly"
      ref="switch"
      v-model="currentValue"
      style="display: inline-block"
      :name="name"
      :required="required"
      :disabled="disabled"
      :active-color="activeColor"
      :inactive-color="inactiveColor"
      :active-text="$t(activeText)"
      :inactive-text="$t(inactiveText)"
      @input="handleModelInput"
    >
    </el-switch>
    <md-input v-if="readonly" v-model="readOnlyValue" :readonly="true" type="text" />
  </div>
</template>
<script>
import MdInput from '../MDinput';
export default {
  components: { MdInput },
  props: {
    name: String,
    value: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    activeColor: {
      type: String,
      default: '#6bb80a'
    },
    inactiveColor: {
      type: String,
      default: '#c7c7c7'
    },
    activeText: {
      type: String,
      default: 'common.switchOn'
    },
    inactiveText: {
      type: String,
      default: 'common.switchOff'
    }
  },
  data() {
    return {
      currentValue: this.value
    };
  },
  computed: {
    readOnlyValue() {
      return this.currentValue ? this.$i18n.t(this.activeText) : this.$i18n.t(this.inactiveText);
    }
  },
  watch: {
    value(newValue) {
      this.currentValue = newValue;
    }
  },
  methods: {
    focus() {
      this.$refs.switch.focus();
    },
    handleModelInput(value) {
      this.$emit('input', value);
      this.$emit('change', value);
    }
  }
};
</script>
<style lang="scss">
.switch-container {
  margin-bottom: 5px;
  .switch-label {
    margin-right: 10px;
  }

  .el-switch > span {
    color: #303133;
  }
}
</style>
